import type { I18nMessage } from "@pollen/core/model/i18n.model";
import type { DropdownMenuItemDefinition } from "@pollen/ui-library";

import type { RouteLocationRaw } from "#vue-router";

/* To be deleted when new navigation will be activated */
export type MainHeaderNavigationItem = {
  label: I18nMessage;
  to: RouteLocationRaw;
};

export function useMainHeaderNavigation() {
  const {
    public: {
      apps: { jobs: jobsUrl },
    },
  } = useRuntimeConfig();
  const router = useRouter();
  const route = useRoute();
  const { data: categoryPages } = useCategoryPageList();

  function groupIsActive(items: DropdownMenuItemDefinition[]) {
    return items
      .map((item) =>
        !item.divider && !item.group && item.to
          ? router.resolve(item.to).path
          : undefined,
      )
      .filter(Boolean)
      .includes(route.path);
  }

  const items = computed<DropdownMenuItemDefinition[]>(() => {
    const resourcesSubNavigation: DropdownMenuItemDefinition[] = [
      {
        label: "Cas clients",
        to: { name: "customer-stories" },
      },
      {
        label: "Blog",
        to: { name: "blog" },
      },
      {
        label: "Comment ça marche",
        to: { name: "enterprise" },
      },
      {
        label: "Devenir trainer",
        to: { name: "become-trainer" },
      },
      {
        label: "Méthodologie",
        to: { name: "methodology" },
      },
      {
        label: "Financement",
        to: { name: "getting-financed" },
      },
      {
        label: "Qui sommes-nous ?",
        to: { name: "about-us" },
      },
      {
        label: "Nous rejoindre",
        href: jobsUrl,
      },
    ];

    return [
      ...categoryPages.value.map((page) => {
        return {
          label: page.title_short,
          to: page._links.page,
        };
      }),
      {
        label: "Événements",
        to: { name: "events" },
      },

      {
        group: true,
        title: "Ressources",
        items: resourcesSubNavigation,
        selected: groupIsActive(resourcesSubNavigation),
      },
    ];
  });

  return { items };
}
